import(/* webpackMode: "eager" */ "/app/src/app/(auth)/forgot-password/page.tsx");
